import SummaryContainer from "./SummaryContainer";
export default SummaryContainer;



// WEBPACK FOOTER //
// src/components/survey/create/Summary/index.js